export const hospitalRoles = [
  { value: 'SENIOR_PHYSICIAN', label: 'רופא/ה בכיר/ה' },
  { value: 'MEDICAL_RESIDENT', label: 'מתמחה' },
  { value: 'NURSE', label: 'אח/ות' },
  { value: 'PARAMEDICAL', label: 'פרא-רפואי' },
  { value: 'ADMINISTRATION', label: 'אדמיניסטרציה' },
  { value: 'OTHER', label: 'אחר' },
];
